import ReviewOutput from '@app/model/review/output/ReviewOutput';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import React, { useEffect, useState } from 'react';
import Utilities from '@util/Utilities';
import FormButton from '@app/component/form/button/FormButton';
import { useQueryClient } from '@tanstack/react-query';
import { ReviewService } from '@app/model/review/service/ReviewService';
import { useReviewsTools } from '@app/site/secured/review-manager/provider/useReviewsTools';

const ReviewViewMessageFragment: React.FunctionComponent<{ reviewOutput: ReviewOutput }> = ({ reviewOutput }) => {

	const tools = useReviewsTools();
	const queryClient = useQueryClient();

	const [showTranslation, setShowTranslation] = useState(false);
	const [isTranslating, setIsTranslating] = useState(false);

	useEffect(() => {
		setShowTranslation(false);
	}, [reviewOutput.review.id]);


	const toggleTranslation = () => {
		if (showTranslation) {
			setShowTranslation(false);
			return;
		}
		if (reviewOutput.review.isNotTranslated()) {
			setIsTranslating(true);
			ReviewService.translateReview(reviewOutput.review.id, tools.filter, queryClient)
				.then(() => setShowTranslation(true))
				.catch((e) => console.error(e))
				.finally(() => setIsTranslating(false));
		} else
			setShowTranslation(true);
	};


	return <div className="bg-white px-4 py-6 shadow sm:rounded-lg sm:px-6">
		<div className="flex items-center border-b border-gray-200 mb-5 pb-2.5">
			<div className="flex items-center space-x-2">
				<FormButton state={showTranslation ? 'primary' : 'white'} extraClassName="h-7"
										onClick={toggleTranslation} isLoading={isTranslating}>{showTranslation ? 'Revert' : 'Translate'}</FormButton>
			</div>
		</div>

		<div className="sm:flex sm:items-baseline sm:justify-between">
			<h3 className="text-base font-medium">
				<span className="text-gray-900">{reviewOutput.review.customerInfo.name || 'A customer'}</span>
				<span className="text-gray-600 ml-1">wrote</span>
			</h3>
			<p className="mt-1 whitespace-nowrap text-sm text-gray-600 sm:ml-3 sm:mt-0">
				<time>{Utilities.formatDateString(reviewOutput.review.reviewDate, 'dddd [at] h:mm a')}</time>
			</p>
		</div>
		<div className="mt-4 space-y-6 text-sm text-gray-800">
			<p className="truncate font-medium mb-2">{showTranslation ? reviewOutput.getTranslatedTitle() : reviewOutput.getTitle()}</p>
			{!reviewOutput.hasContent() && <div>No Content</div>}
			{reviewOutput.getContent()?.map((t, i) =>
				<div key={`text_${i}`} className="w-full mb-1">{showTranslation ? t.translation ?? t.text : t.text}</div>,
			)}
		</div>
	</div>;
};

export default ReviewViewMessageFragment;